// Namespace `inspection` — módulo Inspeção.
// Rótulos normativos da ficha (form §7.3) vivem em `./catalog/`.

import { inspectionCatalogV1PtBR } from "./catalog/v1/pt-BR";

export const inspectionPtBR = {
  title: "Inspeção",
  loading: "Carregando…",
  actions: {
    new: "Nova inspeção",
    openForm: "Abrir ficha",
    delete: "Deletar",
    cancel: "Cancelar",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    save: "Salvar",
    finalize: "Finalizar",
    add: "Adicionar",
    filter: "Filtrar",
    clearFilters: "Limpar filtros",
    download: "Download",
    downloadReport: "Baixar",
  },
  kpi: {
    finalized: "Finalizadas",
  },
  conservationState: {
    title: "Estado de conservação",
    caption:
      "Estado de conservação (atual da estrutura — Classificação ANM)",
    sum: "∑EC",
    empty: "Estado de conservação ainda não preenchido.",
    orient:
      "Assinale o peso correspondente; no caso de peso 10 em qualquer coluna, proceder inspeção especial.",
    specialWarnBefore:
      "Peso 10 selecionado em ao menos uma coluna — proceder ",
    specialWarnEmphasis: "inspeção especial",
    specialWarnAfter: " conforme norma ANM.",
  },
  chart: {
    title: "Acompanhamento",
    period: "Período",
    monthAbbrev: {
      jan: "jan",
      feb: "fev",
      mar: "mar",
      apr: "abr",
      may: "mai",
      jun: "jun",
      jul: "jul",
      aug: "ago",
      sep: "set",
      oct: "out",
      nov: "nov",
      dec: "dez",
    },
    periodMonths: {
      three: "Últimos 3 meses",
      six: "Últimos 6 meses",
      twelve: "Últimos 12 meses",
    },
    empty: "Sem dados no período",
    series: {
      total: "Total",
      finalized: "Finalizadas",
      notFinalized: "Não finalizadas",
      scheduled: "Programadas",
      manual: "Não programadas",
    },
  },
  table: {
    filterButtonText: "Filtros",
    empty: "Nenhuma inspeção cadastrada para esta estrutura.",
    emptyFiltered: "Nenhuma inspeção encontrada com os filtros aplicados.",
    fallback: "—",
    columns: {
      code: "Cod. Inspeção",
      responsible: "Responsável pela inspeção",
      date: "Data",
      conservationState: "Estado de conservação",
      anomalies: "Qntd. Anomalias",
      status: "Status",
      origin: "Origem",
      pdf: "Ficha de inspeção",
    },
    pdfAvailableAfterFinalize: "Disponível após finalizar",
    pdfUnavailable: "Ficha de inspeção ainda não disponível para download",
    pdfPreviewTitle: "Ficha de inspeção",
    pdfVerificationCode: "Código de verificação:",
  },
  status: {
    open: "Aberta",
    inProgress: "em andamento",
    finalized: "finalizada",
    notFinalized: "Não finalizada",
  },
  origin: {
    scheduled: "Programada",
    manual: "Não programada",
  },
  filters: {
    code: "Cod. Inspeção",
    responsible: "Responsável pela inspeção",
    dateFrom: "De",
    dateTo: "Até",
    status: "Status",
    origin: "Origem",
    hasAnomalies: "Com anomalias",
    all: "Todos",
    allFeminine: "Todas",
    yes: "Sim",
    no: "Não",
    codePlaceholder: "Ex.: 42",
    responsiblePlaceholder: "Digite o nome…",
    dateRangeInvalid: "A data inicial não pode ser posterior à data final",
  },
  form: {
    title: "Ficha de inspeção",
    titleWithCode: "Ficha da inspeção #{{code}}",
    unsupportedVersion:
      "Versão de ficha não suportada nesta versão do sistema ({{version}}). Atualize a página; se persistir, acione o suporte.",
    stepsHeading: "Etapas da ficha",
    stepOf: "Etapa {{current}} de {{total}}",
    saveAndContinue: "Salvar e avançar",
    removeOccurrence: "Remover",
    selectPlaceholder: "Selecione…",
    stepLocked: "Avance pelas etapas anteriores para liberar",
    stepIncomplete:
      "Responda os itens obrigatórios deste passo para salvar e avançar. Os campos incompletos estão marcados abaixo.",
    fieldErrorAnswer: "Selecione uma opção.",
    fieldErrorObservations: "Preencha as observações.",
    fieldErrorPhotos: "Envie ao menos uma foto.",
    fieldErrorValue: "Preencha este campo.",
    readOnly: "Somente leitura",
    readOnlyWithStatus: "Somente leitura ({{status}})",
    extrasHint:
      "Participante extra pode ser removido enquanto ainda não assinou.",
    stepNotApplicable:
      "Esta etapa está marcada como não aplicável — os itens ficam ocultos e não entram na contagem de anomalias.",
    stepAppliesQuestion: "Esta etapa se aplica à estrutura?",
    observationsPlaceholder: "Descreva a condição observada…",
    observationsPlaceholderOptional: "Observações (opcional)…",
    anomalyReqNote:
      "Resposta marcada como anomalia — Observações e foto obrigatórias.",
    anomalyReqNoteGrade:
      "“Regular” e “Deficiente” contam como anomalia — Observações e foto obrigatórias.",
    collapseExpand: "Expandir",
    collapseMinimize: "Minimizar",
    occurrenceEmpty: "“Sim” exige ≥ 1 registro. Adicione ao menos um.",
    occurrenceEmptyCrack: "“Sim” exige ≥ 1 registro. Adicione trinca.",
    occurrenceEmptySettlement: "“Sim” exige ≥ 1 registro. Adicione recalque.",
    occurrenceEmptySeepage: "“Sim” exige ≥ 1 registro. Adicione surgência.",
    occurrenceEmptyErosion: "“Sim” exige ≥ 1 registro. Adicione erosão.",
    occurrenceEmptyChannel:
      "“Sim” exige ≥ 1 linha. Adicione ao menos uma linha de canal.",
    occurrenceEmptyGeomembrane:
      "Regular/Deficiente exige ≥ 1 ocorrência de geomembrana.",
    collapseYesPending: "Sim — pendente",
    collapseRecordCount: "{{count}} registro(s)",
    collapseLineCount: "{{count}} linha(s)",
    collapseCleanliness: "Limpeza",
    collapseStructure: "Estrutura",
    pendingSummary: "Pendente",
    optionalSummary: "Opcional",
    occurrencePendingTag: "Registro pendente",
    entryLineTag: "Linha {{n}}",
    drainageChannelDoubleAnomalyHint:
      "Limpeza Regular/Deficiente e estrutura Regular/Deficiente contam como anomalias independentes (+2 nesta linha).",
    anomalyTag: "anomalia",
    naCheckbox: "N/A (não se aplica)",
    entryAnomNote: "Cada registro conta como 1 anomalia.",
    entryAnomNoteGeomembrane: "Cada ocorrência (G1, G2…) conta como 1 anomalia.",
    hintOptional:
      "Opcional — não conta anomalia e não bloqueia finalização.",
    hintInformative:
      "Somente informativo — não conta anomalia e não exige foto.",
    hintInformativeNoNa:
      "Somente informativo — não conta anomalia. Sem opção N/A.",
    extraSourceLegend: "Incluir como",
    extraSourceName: "Pessoa externa",
    extraSourceGs3User: "Usuário do GS3",
    extraSourceHelpAria: "O que é usuário do GS3 e pessoa externa",
    extraSourceHelpGs3:
      "Usuário do GS3: já tem conta no sistema. O nome vem do cadastro.",
    extraSourceHelpExternal:
      "Pessoa externa: não tem conta no GS3. Informe o nome da pessoa.",
    extraDuplicate: "Este participante já está na inspeção.",
    gs3User: "Usuário do GS3",
    gs3UserPlaceholder: "Buscar usuário…",
    gs3UserNotFound: "Nenhum usuário encontrado",
    participantNamePlaceholder: "Nome da pessoa",
    generalData: {
      code: "Código da inspeção",
      responsible: "Responsável pela inspeção",
      date: "Data da inspeção",
      dateScheduledSuffix: "(programada — não pode ser alterada)",
      extraParticipants: "Participantes extras",
      addExtraParticipant: "Adicionar",
      extraParticipantName: "Nome",
    },
    generalComments: {
      label: "Comentários gerais",
      placeholder:
        "Detalhar todos os pontos observados na inspeção, incluir manutenções, obras ou intervenções na estrutura…",
    },
  },
  photos: {
    remove: "Remover",
    expand: "Ampliar {{name}}",
    preview: "Foto {{name}}",
    closePreview: "Fechar foto",
    previous: "Foto anterior",
    next: "Próxima foto",
    counter: "{{current}} de {{total}}",
    save: "Salvar",
    deleteTitle: "Remover foto",
    deleteCaption: "Foto a ser removida:",
    deleteDescription:
      "A foto deixa de aparecer na ficha. Você pode anexá-la de novo se precisar.",
    deleteConfirm: "Remover",
    deleteCancel: "Cancelar",
    // O código canônico entra no texto porque a recusa de formato pode acontecer
    // no seletor do sistema, sem chegar ao handler (error-mapping.mdc).
    acceptHint: "Formatos aceitos: JPEG, PNG ou WebP (recusa: COD. 6.10.15)",
    tooLarge: "Arquivo maior que 10 MB",
  },
  participants: {
    title: "Participantes",
    signLead:
      "Participantes cadastrados em Dados gerais. A assinatura é feita nesta etapa. O botão Finalizar fica só aqui.",
    name: "Nome",
    add: "Adicionar",
    addTitle: "Adicionar participante",
    remove: "Remover",
    signed: "Assinado",
    pending: "Sem assinatura",
    pendingSignature: "Pendente de assinatura",
    sign: "Assinar",
    resign: "Reassinar",
    roleResponsible: "Responsável",
    roleExtra: "Extra",
    kindGs3: "GS3",
    kindExternal: "Externa",
    finalizeHint:
      "Finalizar habilita quando todos os participantes assinarem.",
  },
  signature: {
    titleWithName: "Assinar — {{name}}",
    fonts: {
      classic: "Clássica",
      elegant: "Elegante",
      casual: "Casual",
      bold: "Marcada",
      modern: "Moderna",
      rounded: "Arredondada",
    },
    name: "Nome na assinatura",
    font: "Escolha a fonte de assinatura",
    preview: "Visualização ao vivo",
    confirm: "Confirmar assinatura",
    signedAt: "Assinado em",
  },
  finalize: {
    title: "Finalizar inspeção",
    subtitle:
      "Revise o resumo abaixo. Ao confirmar, a ficha fica somente leitura e o PDF é gerado.",
    warningBefore: "Esta ação ",
    warningIrreversible: "não pode ser desfeita",
    warningAfter:
      ". Após finalizar, nenhum dado da ficha poderá ser alterado.",
    confirm: "Confirmar e finalizar",
    confirming: "Finalizando…",
    cancel: "Cancelar",
    code: "Código",
    inspectionDate: "Data da inspeção",
    signatures: "Assinaturas",
    signaturesOf: "{{signed}} de {{total}}",
    anomalyCount: "Quantidade de anomalias",
    ecSum: "Somatório EC",
  },
  delete: {
    title: "Excluir item permanentemente",
    caption: "Item a ser excluído:",
    description:
      "Esta ação é irreversível. Os dados não poderão ser recuperados após a exclusão.",
    confirm: "Excluir",
    cancel: "Cancelar",
    item: "Inspeção #{{code}} — {{date}}",
  },
  catalog: {
    v1: inspectionCatalogV1PtBR,
  },
};
